import { instantSearchIsOpen, isAlgoliaPage, replaceStr, getUrlParameter } from './Utility'

/**
 * @returns {String}
 *
 * @memberof TrackingUtility
 */
const getSearchQuery = () => {
	const algoliaElement = document.querySelector('algolia-element')
	return algoliaElement?.search?.helper?.state?.query ?? getUrlParameter('query')
}

/**
 * @returns {String}
 *
 * @memberof TrackingUtility
 */
const getPrddisplay = () => window.tc_vars?.prddisplay || document.body.dataset.seoPageTemplate

/**
 * @returns {String}
 *
 * @memberof TrackingUtility
 */
const getCategoryPguriSegment = () => {
	const navigationCategory = [
		window.tc_vars?.nav_categoryIdentifier1,
		window.tc_vars?.nav_categoryIdentifier2,
		window.tc_vars?.nav_categoryIdentifier3,
		window.tc_vars?.nav_categoryIdentifier4,
	]

	navigationCategory.forEach((category, index) => {
		if (!category) {
			navigationCategory.splice(index, 1)
		} else {
			navigationCategory[index] = replaceStr(
				category,
				[`${category.split('_')[0]}_`, '_'],
				['', '-']
			).toLowerCase()
		}
	})

	return navigationCategory.join('/')
}

/**
 * @returns {String}
 *
 * @memberof TrackingUtility
 */
const getPguri = () => {
	const pageType = isAlgoliaPage() ? 'algoliaPage' : window.tc_vars?.nav_GAsection

	let cultureRegex = /^\/[a-zA-Z]{2}-[a-zA-Z]{2}\//g

	if (pageType === 'cart' || pageType === 'confirmation') {
		cultureRegex = /^\/[a-zA-Z]{2}\//g
	}

	if (pageType === 'home') {
		cultureRegex = /^\/[a-zA-Z]{2}-[a-zA-Z]{2}/g
	}

	const culture = document.documentElement.dataset.culture.replace('-', '_').toLowerCase()
	const pagePath = window.location.pathname.replace(cultureRegex, `/${culture}/`)

	let pgUri = ''

	switch (pageType) {
		case 'item':
			const { product_eng_category, product_eng_micro, product_mfPartNumber } = window.tc_vars

			const line = `${product_eng_category?.replace(/ /g, '-').toLowerCase()}/`
			const micro = `${product_eng_micro?.replace(/ /g, '-').toLowerCase()}/`

			pgUri = `/${culture}/collections/${line}${micro}${product_mfPartNumber}`
			break
		case 'searchresult':
			pgUri = `/${culture}/${getCategoryPguriSegment()}`
			break
		case 'home':
			pgUri = `${pagePath}home/homepage`
			break
		case 'algoliaPage':
			pgUri = `${pagePath}?query=${getSearchQuery()}&queryCat=Search`
			break
		default:
			pgUri = pagePath
			break
	}

	if (instantSearchIsOpen()) {
		pgUri = `${pgUri}?query=${getSearchQuery()}&queryCat=instantSearch`
	}

	return pgUri
}

/**
 * @param {HTMLElement} productSlotTarget
 * @returns {String}
 *
 * @memberof TrackingUtility
 */
const getListName = (productSlotTarget) => {
	let listName = window.tc_vars?.listname

	if (!productSlotTarget) {
		return listName
	}

	const typeSlider = productSlotTarget.closest(
		'.product-carousel, .slider-element, .editorial-carousel'
	)?.dataset.contentId

	switch (typeSlider) {
		case 'youMayAlsoLike':
			listName = `Product pages: Other suggestions`
			break
		case 'alsoAvailable':
		case 'relatedCreations':
			listName = `Product pages: Similar suggestions`
			break
		case 'productsVariants':
			listName = `Product pages: Product Variations`
			break
		case 'BestSellerProducts':
			if (isAlgoliaPage()) {
				listName = `Search pages: Other suggestions`
			} else if (instantSearchIsOpen()) {
				listName = `Instant search pages: Other suggestions`
			} else {
				listName = `${getPrddisplay()}: Other suggestions`
				break
			}
			break
		default:
			if (isAlgoliaPage()) {
				listName = `Search pages: product listing`
			} else if (instantSearchIsOpen()) {
				listName = `Instant search pages: product listing`
			} else {
				listName = `${getPrddisplay()}: product listing`
				break
			}
			break
	}

	return listName
}

/**
 * @param {HTMLElement} productSlotTarget
 * @param {Object|String} trackObjData
 * @returns {Object}
 *
 * @memberof TrackingUtility
 */
const productDataEnhance = (trackObjData, productSlotTarget = null) => {
	const productData = typeof trackObjData === 'string' ? JSON.parse(trackObjData) : trackObjData

	const buyable = productSlotTarget?.dataset.buyable?.toString()?.toLocaleLowerCase()
	const sellableData = productData.product_sellable?.toLowerCase()
	const sellable = buyable === 'true' || sellableData === 'online' ? 'sellable' : 'notsellable'

	if (typeof productData.product_is_in_stock === 'boolean') {
		productData.product_is_in_stock = productData.product_is_in_stock ? 'instock' : 'notinstock'
	}

	if (productSlotTarget) {
		productData.position = parseInt(
			productSlotTarget?.dataset.position ?? productData.position,
			10
		)
		productData.list = `${getListName(productSlotTarget)} - ${getPguri()}`
	}

	if (productData.dataSt?.isStrap) {
		productData.prddisplay = window.tc_vars?.prddisplay
		productData.prdid = productData.mfPartNumber
		productData.product_mfPartNumber =
			productData.product_mfPartNumber || productData.mfPartNumber
		productData.quantity = 1
		productData.category = 'WBR'
		productData.prdcategory = 'WBR'
		productData.productAvailability = true
		productData.skuMfPartNumber = productData.skuMfPartNumber || productData.mfPartNumber || ''
		productData.product_defaultMfPartNumber = ''
		productData.product_size = ''
		productData.personalizationType = ''
		productData.product_engravable = ''
		productData.product_embossable = ''
		productData.product_adjustable = ''
		productData.product_eng_casematerial = ''
		productData.product_eng_jewelmaterial = ''
		productData.product_eng_strapmaterial = ''
		productData.product_eng_leathermaterial = ''
		productData.product_eng_title =
			productData.prdname || productData.shortDescription || productData.product_eng_color
		productData.product_brand = productData.product_brand || productData.brand
		productData.product_discountedPrice =
			productData.product_discountedPrice || productData.discount_price_ati
		productData.dataSt.prdcategory = 'Bracelet'
		productData.dataSt.prdline = 'WBR'
		productData.dataSt.prdcollection = 'WBR'
		productData.dataSt.prdsellable = 'sellable'
		productData.dataSt.prddisplay = window.tc_vars?.prddisplay

		return productData
	}

	productData.dataSt = {
		prdcategory: productData.product_eng_micro,
		prdline: productData.product_eng_category,
		prdcollection: productData.product_eng_collection,
		prdsubcollection: productData.product_eng_subcollection,
		variant: productData.product_eng_color,
		list: `${getListName(productSlotTarget)} - ${getPguri()}`,
		prdsellable: sellable,
		prdvariant: productData.product_eng_color,
		// prdadjusted: 'No',
		prddisplay: window.tc_vars?.prddisplay,
	}

	return productData
}

/**
 * @param {String} partNumber
 * @param {Number} [position = 0]
 * @returns {Object}
 * @async
 *
 * @memberof TrackingUtility
 */
const getTrackProductData = async (partNumber, position = 0) => {
	const options = {
		data: {
			partNumber,
			position,
		},
	}
	const trackingData = await yTos.fetch('/api/ItemData/GetProductTrackData', options)
	const data = await trackingData.json()

	if (data.product_eng_category.toLowerCase() === 'wbr') {
		data.dataSt = {}
		data.dataSt.isStrap = true
	}

	return data
}

/**
 * @param {String} eventName String to be passed as "event" property in the resulting Object
 * @returns {Object} a typical Tracking data object for the PDP
 *
 * @memberof TrackingUtility
 */
const getItemPageCommonData = (eventName) => ({
	event: eventName,
	category: 'Product Page',
	prdline: () => window.tc_vars?.product_eng_category,
	prdcollection: () => window.tc_vars?.product_eng_collection,
	prdsubcollection: () => window.tc_vars?.product_eng_subcollection,
	prdsellable: () =>
		window.tc_vars?.product_status === 'NOTBUYABLE' ? 'notsellable' : 'sellable',
	prdid: () => window.tc_vars?.product_mfPartNumber,
})

/**
 * This method check is AnalyticsCookie is enable from TC
 *  7 = COOKIE ANALITICI
 *  @returns {Boolean}
 */
const isAnalyticsCookieEnabled = () => {
	const consentPrivacyCookie = window.tC?.privacy?.getConsent()?.consent

	if (!consentPrivacyCookie) return false

	if (consentPrivacyCookie && consentPrivacyCookie.status === 'all-off') return false
	if (consentPrivacyCookie && consentPrivacyCookie.status === 'all-on') return true

	const categoriesPrivacyCenter = consentPrivacyCookie.categories

	return categoriesPrivacyCenter[7]?.status
}

/**
 * This method return CategoryArea
 *
 *  @returns {String}
 */
const getCategoryArea = () =>
	window.location.pathname.indexOf('faq') !== -1
		? 'Faq Pages'
		: document.body.dataset.seoPageTemplate

/**
 * @param {String} queryID queryID if present
 * @param {String} refNumber refNumber of the item
 * @param {Number} position position of the item
 *
 * @memberof TrackingUtility
 */
const clickedObjectIDsAfterSearch = (queryID, refNumber, position) => {
	if (yTos.Cartier?.Algolia?.SearchInsights && isAnalyticsCookieEnabled()) {
		yTos.Cartier.Algolia.SearchInsights('clickedObjectIDsAfterSearch', {
			eventName: 'PLP: Product Clicked - after search',
			index: yTos.Cartier.Algolia.Index,
			queryID,
			objectIDs: [refNumber],
			positions: [position + 1],
			userToken: yTos.Cartier.Algolia?.UserToken ?? 'user',
		})
	}
}

/**
 * @method getWishlistTrackingData
 * @param {Object} trackingObj
 * @param {String} partNumber
 * @param {String} sizeForOneSizeProduct
 * @description maps data for add to wishlist tracking, from standard item track data object
 *
 * @memberof TrackingUtility
 * */
const getWishlistTrackingData = (trackingObj, partNumber, sizeForOneSizeProduct = null) => {
	let size

	if (typeof yTos.models.ProductsCollection === 'function') {
		const productModel = yTos.models.ProductsCollection({
			scope: partNumber,
		})

		size = productModel?.get('selectedSize')
	}

	if (!size) {
		size = sizeForOneSizeProduct
	}
	const data = {
		event: 'add_to_wishlist',
		pid: trackingObj.product_cod10,
		name: trackingObj.product_title,
		category: trackingObj.product_category,
		brand: trackingObj.product_brand,
		variant: trackingObj.product_eng_color || '',
		price: trackingObj.product_price,
		discount_price: trackingObj.product_discountPrice,
		price_ati: trackingObj.product_price_ati,
		discount_price_ati: trackingObj.product_discountedPrice,
		quantity: trackingObj.product_quantity || 1,

		product_variant_id: trackingObj.product_variant_id,
		product_id: trackingObj.product_id,
		legacy_micro_id: trackingObj.product_legacy_micro_id,
		legacy_macro_id: trackingObj.product_legacy_macro_id,

		prdid: trackingObj.product_mfPartNumber,
		prdname: trackingObj.product_eng_title,
		prdcategory: trackingObj.product_micro_category,
		productLine: trackingObj.product_line,
		productCollection: trackingObj.product_collection,
		productSubcollection: trackingObj.product_subcollection,
		productEngravable: trackingObj.product_engravable,
		productEmbossable: trackingObj.product_embossable,
		productEngraved: trackingObj.product_engraved,
		productEmbossed: trackingObj.product_embossed,
		productAdjustable: trackingObj.product_adjustable,
		productAdjusted: trackingObj.product_adjusted,
		personalizationType: trackingObj.product_personalizationType,
		mfPartNumber: trackingObj.product_mfPartNumber,
		productAvailability: trackingObj.product_is_in_stock,
		productCaseMaterial: trackingObj.product_eng_casematerial,
		productJewelryMaterial: trackingObj.product_eng_jewelmaterial,
		productStrapMaterial: trackingObj.product_eng_strapmaterial,
		productLeatherMaterial: trackingObj.product_eng_leathermaterial,
		productSize: size,
		productSkuMfPartNumber: trackingObj.product_mfPartNumber,
		product_eng_color: trackingObj.product_eng_color,
		product_eng_category: trackingObj.product_eng_category,
		product_eng_leathermaterial: trackingObj.product_eng_leathermaterial,
		product_eng_strapmaterial: trackingObj.product_eng_strapmaterial,
	}
	data.prddisplay = window.tc_vars?.prddisplay
	data.dataSt = {
		prdcategory: trackingObj.product_eng_micro,
		prdline: trackingObj.product_eng_category,
		prdcollection: trackingObj.product_eng_collection,
		prdsubcollection: trackingObj.product_eng_subcollection,
		variant: trackingObj.product_eng_color,
		list: window.tc_vars?.listname,
		prddisplay: window.tc_vars?.prddisplay,
		prdsellable: trackingObj.product_sellable,
		prdvariant: trackingObj.product_eng_color,
	}

	return data
}

export {
	productDataEnhance,
	getTrackProductData,
	getListName,
	getPguri,
	getPrddisplay,
	getItemPageCommonData,
	isAnalyticsCookieEnabled,
	getCategoryArea,
	clickedObjectIDsAfterSearch,
	getWishlistTrackingData,
}
